var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.72656C13.8055 8.72656 15.2728 10.1938 15.2728 11.9993C15.2728 13.8048 13.8055 15.272 12 15.272C10.1946 15.272 8.72729 13.8048 8.72729 11.9993C8.72729 10.1938 10.1946 8.72656 12 8.72656Z",
    fill: "#151B26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.81787C17.4545 3.81787 22.1127 7.21057 24 11.9997C22.1127 16.7888 17.4545 20.1815 12 20.1815C6.54004 20.1815 1.88729 16.7888 0 11.9997C1.88729 7.21057 6.54004 3.81787 12 3.81787ZM12 17.4542C15.0109 17.4542 17.4545 15.0106 17.4545 11.9996C17.4545 8.98873 15.0109 6.54513 12 6.54513C8.98911 6.54513 6.54546 8.98878 6.54546 11.9997C6.54546 15.0106 8.98911 17.4542 12 17.4542Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default ForwardRef;